import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as pathUtils from "../../../utils/pathUtils";
import * as systemUtils from "../../../utils/systemUtils";
import * as typeUtils from "../../../utils/typeUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/parameterAbstract";
import { getParameterReferences, processParameterReferences } from "./helpers/parameterHelper";

const _action = `${ACTION_PREFIX_PARAMETER}_detach`;
const _header = `Create parameter`;

export const detachParameter = (root, id) => {
  const _payload = detachParameterLogic(root, id);

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const detachParameterLogic = (root, id) => {
  const _idParent = pathUtils.getIdParent(id);
  const { data: _node, index: _index } = getNodeById(root, id);
  const { data: _nodeParent } = getNodeById(root, _idParent);
  const { data: _nodeTarget } = getNodeById(root, nodeUtils.getIdTarget(_node));

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getParameterReferences(root, _node);

  copyChildren(_node, _nodeTarget);
  removeReferences(_node, _nodeTarget, id);
  changeType(_node);

  nodeUtils.updateNode(_node, _idParent);

  handleReferences(root, _references, id);

  return generatePayload(_nodeBackup, _index, _nodeParent, _references.description);
};

const copyChildren = (node, nodeTarget) => {
  nodeUtils.setParameters(node, systemUtils.createDeepCopy(nodeUtils.getParameters(nodeTarget)));
  nodeUtils.setChoices(node, systemUtils.createDeepCopy(nodeUtils.getChoices(nodeTarget)));
};

const removeReferences = (node, nodeTarget, id) => {
  nodeUtils.setIdTarget(node, null);
  nodeUtils.removeIdReference(nodeTarget, id);
};

const changeType = (node) => {
  const _isParameterGlobal = nodeUtils.isParameterGlobal(node);
  const _parameterType = _isParameterGlobal
    ? typeUtils.getTypeParameterGlobal()
    : typeUtils.getTypeParameter();
  nodeUtils.setType(node, _parameterType);
};

const handleReferences = (root, references, id) => {
  const funTarget = (e) => {
    nodeUtils.removeIdReference(e.dst, id);
  };

  const funTargetIndirect = (e) => {
    detachParameterLogic(root, nodeUtils.getID(e.src));
  };

  processParameterReferences(references, funTarget, funTargetIndirect);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, nodeParent, uuidReferences) => {
  const _payload = {
    group: ActionGroupTypes.DELETE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node),
    node: node,
    uuid: nodeUtils.getUUID(node),
    uuidParent: nodeUtils.getUUID(nodeParent),
    index: index,
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadDescription = (node) => {

  return `Detach parameter '${nodeUtils.getName(node)}'.`;
}